import "slick-carousel";

export default class DafLearn {
    constructor() {
        this.init();
    }

    init() {
        $(document).on('click', '.lesson-page', function(e) {
            e.preventDefault();

            const container = $('#lessons_list');
            let page = $(this).data('page');
            let course_id = container.data('course-id');
            let all = container.data('count');
            let per_page = container.data('per-page');


            $.ajax({
                url: myAjax.ajaxurl,
                type: 'POST',
                data: {
                    action: 'lessons_list_ajax',
                    course_id: course_id,
                    page: page,
                    all: all,
                    per_page: per_page
                },
                beforeSend: function() {
                    $('#lessons_list').addClass('loading');
                },
                success: function(response) {
                    $('#lessons_list').removeClass('loading');
                    if (response.success) {
                        $('#lessons_list').html(response.data);
                    }
                }
            });
        });
    }
}